const serviceNameMapping = {
  'SIPPROXY-SIGNALING-ESTABLISHED': {
    display: 'SIP: SIGNALING ESTABLISHED',
    status: 'success',
  },
  'SIPPROXY-NOT-A-SUBSCRIBER': {
    display: 'SIP: NOT A SUBSCRIBER',
    status: 'failure',
  },
  'SIPPROXY-INCOMING-CALL': {
    display: 'SIP: INCOMING CALL',
    status: 'success',
  },
  'SIPPROXY-HANGUP-TO-SIP': {
    display: 'SIP: HANGUP TO SIP',
    status: 'success',
  },
  'SIPPROXY-HANGUP-TO-RTC': {
    display: 'SIP: HANGUP TO RTC',
    status: 'success',
  },
  'SIPPROXY-FARSIDE-RINGING': {
    display: 'SIP: FARSIDE RINGING',
    status: 'success',
  },
  'SIPPROXY-CALL-SETUP-IN-PROGRESS': {
    display: 'SIP: CALL SETUP IN PROGRESS',
    status: 'success',
  },
  'SIPPROXY-CALL-REJECTED': {
    display: 'SIP: CALL REJECTED',
    status: 'failure',
  },
  'NTM-RECEIVED-PUBLISH_REQUEST': {
    display: 'NTM: RECEIVED PUBLISH REQUEST',
    status: 'success',
  },
  'NTM-PUBLISH-ERROR': {
    display: 'NTM: PUBLISH ERROR',
    status: 'failure',
  },
  'NTM-NOTIFIED-WSS': {
    display: 'NTM: NOTIFIED WSS',
    status: 'success',
  },
  'NTM-NO-SUBSCRIPTIONS': {
    display: 'NTM: NO SUBSCRIPTIONS',
    status: 'failure',
  },
  'EVM-RESOURCE-ALLOCATION_FAILURE': {
    display: 'EVM: RESOURCE ALLOCATION FAILURE',
    status: 'failure',
  },
  'EVM-RESOURCE-ALLOCATED': {
    display: 'EVM: RESOURCE ALLOCATED',
    status: 'success',
  },
};

const convertDisplayName = data => (serviceNameMapping[data] !== undefined
  ? serviceNameMapping[data]
  : { display: data, status: 'unknown' });

const sortStringData = function sortStringData(data, sortvalue, sortreverse) {
  const sortBy = (field, reverse, primer) => {
    const key = primer
      ? x => primer(x[field])
      : x => x[field];

    const reverse1 = !reverse ? 1 : -1;

    return (a, b) => {
      const a1 = key(a);
      const b1 = key(b);
      return reverse1 * ((a1 > b1) - (b1 > a1));
    };
  };

  let sortorder = true;
  if (sortreverse !== undefined && !sortreverse) {
    sortorder = false;
  }

  if (data[0]) {
    return data.sort(sortBy(sortvalue, sortorder));
  }
  return data;
};

const processCallDetails = (data) => {
  const callData = {};
  let callTuple = {};
  let milestoneTuple = {};

  Object.keys(data).forEach((idx) => {
    if (data[idx] !== undefined) {
      const traceId = data[idx].key;
      let callStatus = 'success';
      const details = data[idx].milestones.buckets;
      callTuple = { traceId, values: [] };
      let topSrcTN = '__missing__';
      let topDstTN = '__missing__';

      Object.keys(details).forEach((mst) => {
        if (details[mst] !== undefined) {
          const milestone = details[mst].key;
          const eventMap = convertDisplayName(milestone);
          const milestoneDisplay = eventMap.display;
          const milestoneStatus = eventMap.status;
          const timestamps = details[mst].timestamp.buckets;
          if (milestoneStatus === 'failure') callStatus = 'failure';

          Object.keys(timestamps).forEach((itm) => {
            if (timestamps[itm] !== undefined) {
              const timestamp = timestamps[itm].key;
              const srcTN = timestamps[itm].srcTN.buckets[0].key;
              if (srcTN !== '__missing__') topSrcTN = srcTN;
              const dstTN = timestamps[itm].srcTN.buckets[0].dstTN.buckets[0].key;
              if (dstTN !== '__missing__') topDstTN = dstTN;

              milestoneTuple = {
                milestone,
                milestoneDisplay,
                milestoneStatus,
                timestamp,
                srcTN,
                dstTN,
              };
              callTuple.srcTN = topSrcTN;
              callTuple.dstTN = topDstTN;
              callTuple.callStatus = callStatus;
              callTuple.values.push(milestoneTuple);
            }
          });
        }
      });

      callTuple.values = sortStringData(callTuple.values, 'timestamp', false);
      callData[traceId] = callTuple;
    }
  });

  return callData;
};

export default processCallDetails;
